import React from 'react';
import { history } from 'containers/App';

import ErrorPage from 'components/Errors/ErrorPage';

const UnsupportedError = () => <ErrorPage title="Unsupported" type="unsupported" showButton buttonText="Exit" onButtonClick={ () => { history.push('/'); window.location.reload(); } }>
  <p>This feature is not currently supported.</p>
</ErrorPage>;

export default UnsupportedError;
